import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import UsersService from "../../services/usersService";
import ToastrNotification from "../../components/toastrNotification ";

function ImpersonateModal({ show, handleClose, allUsersData }) {
  console.log("allUsersData ", allUsersData);

  const [selectedUser, setSelectedUser] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const showToast = (message, type) => {
    ToastrNotification(message, type);
  };
  const handleChange = async (id) => {
    const getSelectedUser = allUsersData.filter((user) => user.UserId === id);
    getSelectedUser && setSelectedUser(getSelectedUser);
  };

  const handleSubmit = async () => {
    const userData = localStorage.getItem("userData");
    const currentImpersonateData = {
      ImpersonateBy: JSON.parse(userData).userId,
      ImpersonateFor: selectedUser[0]?.UserId,
    }

    if(selectedUser.length === 0){
      showToast('Please select a user to impersonate', "error");
      return;
    }else{
      await UsersService.addImpersonateUser(currentImpersonateData)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Network response was not ok");
        } else if(response.status === 200){
          const newObj = selectedUser.length > 0 && {
            userEmail: selectedUser[0].Email,
            userId: selectedUser[0].UserId,
            userName: selectedUser[0].UserName,
            userRole: selectedUser[0].RoleName,
            userShortName: selectedUser[0].FirstName,
          };
        
      
          localStorage.setItem("userImpersonateData", userData);
          localStorage.setItem("userData", JSON.stringify(newObj));
      
          let url = "";
          if (newObj.userRole === "Admin") {
            url = "/dashboard";
          } else if (newObj.userRole === "DataProvider") {
            url = "/serviceprovider-dashboard";
          } else if (newObj.userRole === "Reviewer") {
            url = "/reviewer-dashboard";
          }
      
          if (url) {
            navigate(url);
          }
        }
      
        
        handleClose();
  
      })
      .catch((err) => {
        showToast('Error - please contact your administrator.', "error");
      })
    }


  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" backdrop={"static"} keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{t("Header.Impersonate")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div class="row">
            <div class="col-12 mb-3 fund2 multiSelect multiSelect4">
              <label for="sataset" class="col-form-label">
                {t("Header.Select_User")}
              </label>
              <select
                name="serviceProvider"
                id="serviceProvider"
                className="form-select"
                onChange={(e) => handleChange(e.target.value)}
              >
                <option value="">{t("Header.Select_User")}</option>
                {allUsersData.length > 0 &&
                  [...new Map(allUsersData.map((user) => [user.UserName, user])).values()].map((user) => (
                    <option key={user.UserId} value={user.UserId}>
                      {user.UserName}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t("Header.Close")}
        </Button>
        <Button variant="primary" onClick={() => handleSubmit()}>
          {t("Header.Save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImpersonateModal;
